export const env = process.env.REACT_APP_ENV;
export const version = process.env.REACT_APP_BUILD_NUMBER || "0.0.0";
export const MajorVersion = process.env.REACT_APP_MAJORVERSION || "1.0.0";
export const apiUrl = process.env.REACT_APP_API_URL;
export const msalRedirectURL = process.env.REACT_APP_MSALREDIRECT;
export const jllSSOIssuer = process.env.REACT_APP_JLLSSOISSUER;
export const jllSSOClientId = process.env.REACT_APP_JLLSSOCLIENTID;
export const jllSSORedirectUri = process.env.REACT_APP_JLLSSOREDIRECTURI;
export const LEEBUILDMESOMETHING = process.env.REACT_APP_JLLSSOREDIRECTURI;